<template>
    <PopoverRight ref="popoverContent" width="700px" >
        <div class="popover-slider-bar">
            <h1 class="bar-title">新增问答规则</h1>
            <div class="tips-wrapper clearfix">
                <div class="left">提示：</div>
                <div class="right">
                    <p>1.问答规则中可调用的标签及标签规则，可下载<a :href="modelDownload" class="">“话题建模标签表”</a> 查看</p>
                </div>
            </div>
            <el-form class="form-container" :rules="rules" :model="formData" ref="manyAsksForm">
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">问答结构</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item  prop="type">
                            <el-select v-model="formData.type" filterable placeholder="请选择" @change="changeType">
                                <el-option
                                v-for="item in typeList"
                                :key="item.id"
                                :label="item.value"
                                :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-item" v-if="formData.type != 1">
                    <template v-if="formData.type == 3">
                        <div class="form-label">
                            <span class="label">话题名称</span>
                        </div>
                        <div class="form-input-item">
                            <el-form-item  prop="">
                                <el-select v-model="formData.topic_id" filterable placeholder="请选择">
                                    <el-option
                                    v-for="item in topicList"
                                    :key="item.value"
                                    :label="item.topic_name"
                                    :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </template>
                    <template v-else>
                        <div class="form-label">
                            <span class="label">话题名称</span>
                            <label class="warn">*</label>
                        </div>
                        <div class="form-input-item">
                            <el-form-item  prop="topic_id">
                                <el-select v-model="formData.topic_id" filterable placeholder="请选择">
                                    <el-option
                                    v-for="item in topicList"
                                    :key="item.value"
                                    :label="item.topic_name"
                                    :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </template>
                </div>
                <el-card class="box-card">
                    <i class="el-icon-close"></i>
                    <div class="form-item">
                        <div class="form-label">
                            <span class="label">问题规则</span>
                            <label class="warn">*</label>
                        </div>
                        <div class="form-input-item">
                            <el-form-item 
                                :prop="'asks_name'" 
                                :rules="askRule"
                            >
                                <el-input placeholder="请输入问题规则" class="input-control" v-model="formData.asks_name"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="form-item" v-if="formData.type != 1">
                        <div class="form-label">
                            <span class="label">回答规则 </span>
                            <label class="warn">*</label>
                        </div>
                        <div class="form-input-item">
                            <el-form-item 
                                :prop="'answer_name'" 
                                :rules="awnRule"
                            >
                                <el-input type="textarea" placeholder="请输入回答规则" class="input-control" v-model="formData.answer_name"></el-input>
                            </el-form-item>                            
                        </div>
                    </div>
                </el-card>
                <div class="align-center">
                    <el-button @click="hideMenu">取消</el-button>
                    <el-button type="primary" @click="submitForm('manyAsksForm')" >确定</el-button>
                </div>
            </el-form>
        </div>
    </PopoverRight>
</template>
<script>
import PopoverRight from '@/components/popoverRight/index'
import {getBanklList,editAssembleAsks} from '@/service/topicBank'

export default {
    name: 'edit',
    components: {
        PopoverRight,
    },
    props: {
        callback: Function,
        asksInfo:Object
    },
    data () {
        return {
            formData:{
                type:"",
                topic_id:'',
                ask_name:"",
                answer_name:""
            },
            typeList:[
                    {
                        id:1,
                        value:"前缀"
                    },{
                        id:2,
                        value:"中心"
                    },{
                        id:3,
                        value:"后缀"
                    }
                ],
            rules: {
                topic_id: [
                    { required: true, message: '请输入话题关键词', trigger: 'blur' },
                ],
               
            },
            askRule: [
                { required: true, message: '问题规则不能为空', trigger: 'blur' },
                { min: 1, max:50, message: '问题规则为1-50个字符之间', trigger: 'blur' },
            ],
            awnRule: [
                { required: true, message: '回答规则不能为空', trigger: 'blur' },
                { min: 1, max:999, message: '回答规则为1-999个字符之间', trigger: 'blur' },
            ],
            modelDownload:"",
            topicList:[],
        }
    },
    watch: {
        asksInfo:{
            handler(newVal){
                this.formData = {
                    id:newVal.id,
                    type:newVal.type,
                    topic_id:newVal.topic_id,
                    asks_name:newVal.ask_name,
                    answer_name:newVal.answer_name
                }
            },
            deep:true
        }
    },

    mounted(){
        this.initData()
        const domain=document.domain;
        const host = window.serverConfig[window.siteMap[domain]].VUE_APP_FRIEND_LINK_URL;
        this.modelDownload = host+'话题建模规则-调用标签.xlsx';
    },
    methods: {
        changeType(value){
            this.formData = {
                id:this.asksInfo.id,
                type:value,
                topic_id:'',
                asks_name:"",
                answer_name:""
            }
        },
        initData(){
            getBanklList({
                per_page: 999,
                page: 1
            }).then(res => {
                this.topicList = res.data
            })
        },
        /** 打开右侧悬浮层 */
        openMenu (id) {
            this.$refs.popoverContent && this.$refs.popoverContent.open()
        },
        /** 关闭右侧悬浮层 */
        hideMenu () {
            this.resetForm()
            this.$refs.popoverContent && this.$refs.popoverContent.hide()
            this.$refs.manyAsksForm && this.$refs.manyAsksForm.clearValidate()
        },
        resetForm () {
            this.formData = {
                type:"",
                topic_id:'',
                asks_name:"",
                answer_name:""
            }
        },
        submitForm (formName) {
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    editAssembleAsks(this.formData.id,this.formData).then((data) => {
                        this.$message({
                            message: '修改成功',
                            type: 'success',
                            duration: 3 * 1000
                        })
                        this.hideMenu()
                        this.callback && this.callback();
                    }).catch(err => {
                        this.$message({
                            message: err.message || '修改失败',
                            type: 'error',
                            duration: 3 * 1000
                        })
                    })
                    
                } else {
                    return false
                }
            })
        },
    }
}
</script>
<style scoped>
.site-sp {
  display: block !important;
  padding-left: 30px;
}
.site-label {
  width: 100%;
  height: 30px;
}
.site-label .ipt {
  margin-right: 20px;
}
.form-input-site {
  min-height: 100px;
  width: 100%;
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #ddd;
  padding: 20px;
  box-sizing: border-box;
}
.form-input-site label {
  margin-right: 15px;
  padding-bottom: 10px;
  display: inline-block;
}
.form-input-site label input {
  margin-right: 5px;
}
.popover-slider-bar .form-container .form-item .form-label {
    width: 20%;
}
.popover-slider-bar .form-container .form-item .form-input-item {
    width: 50%;
}
.tips-wrapper{
    width: 100%;
    margin-top:20px;
}
.tips-wrapper .left{
    width: 15%; 
    float: left;
    text-align: right;
    line-height:30px;
}
.tips-wrapper .right{
     float: left;
     width:85%;
}
.tips-wrapper .right p{
    line-height: 30px;
}
.tips-wrapper .right a{
    text-decoration: none;
    color: #409EFF;
}
</style>